import React from 'react';

export default function Weapons() {
  return <div>weapons</div>;
}
